import React from "react";
import { observer } from "mobx-react";
import type { WalletStore } from "../../stores/wallet/wallet-store";
import { Button } from "../../../../components/inputs/button/button";
import { ButtonIcon } from "../../../../components/inputs/button-icon/button-icon";
import IconDelete from "../../../../components/icons/icon-delete/icon-delete";
import IconEdit from "../../../../components/icons/icon-edit/icon-edit";
import { FONT_COLOR } from "../../../../components/fonts/font-props";
import FontBody2 from "../../../../components/fonts/font-body2/font-body2";
import ConfirmDeletePaymentMethodModal from "./confirm-delete-payment-method-modal";
import { BUTTON_VARIANTS } from "../../../../components/inputs/button-variants";
import IconPlus from "../../../../components/icons/icon-plus/icon-plus";
import PaymentMethodLogo from "../../../../components/payment-method-logo/payment-method-logo";
import WalletPaymentMethodErrorIcon from "./wallet-payment-method-error-icon";
import "./wallet-payment-method.scss";

interface Props {
    walletStore: WalletStore;
    shouldConfirmPaymentMethodDeletions?: boolean;
}

const WalletPaymentMethod: React.FC<Props> = observer(({walletStore, shouldConfirmPaymentMethodDeletions = true} :Props) => {
    
    const handleDeletePaymentMethod = () => {
        if (shouldConfirmPaymentMethodDeletions) {
            walletStore.setShouldShowDeletePaymentMethodModal(true);
        } else {
            walletStore.deletePaymentMethodHandler();
        }
    }
    
    return (
        <div className="wallet-payment-method">
            {walletStore.hasPaymentMethod ? (
                    <>
                        <div className={`wallet-payment-method-existing-card ${walletStore.paymentMethodError ? ' wallet-payment-method-existing-card-with-error' : ''}`}>
                            <div className="wallet-payment-method-existing-card-details">
                                <div className="wallet-payment-method-brand-container">
                                    <div className="wallet-payment-method-brand-logo">
                                        <PaymentMethodLogo paymentMethodName={walletStore.brand} />
                                    </div>
                                    <div className="wallet-payment-method-details">
                                        <div className="wallet-payment-method-details-row">
                                            <FontBody2 color={FONT_COLOR.PRIMARY2}>{walletStore.brandCapitalized}{" "}</FontBody2>
                                            <FontBody2 color={FONT_COLOR.PRIMARY2}>{"****"}{walletStore.last4}</FontBody2>
                                        </div>
                                        <div>
                                            <FontBody2 color={FONT_COLOR.PRIMARY2}>Expires: {walletStore.expiration}</FontBody2>
                                        </div>
                                    </div>
                                    {walletStore.paymentMethodError && (
                                        <div className="wallet-payment-method-error-icon-container">
                                            <WalletPaymentMethodErrorIcon
                                                errorText={walletStore.paymentMethodError}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="wallet-payment-method-actions">
                                <ButtonIcon onClick={handleDeletePaymentMethod} Component={() => <IconDelete color={'var(--color-accent-1)'}/>} />
                                <ButtonIcon onClick={walletStore.addPaymentMethodHandler} Component={() => <IconEdit color={'var(--color-accent-1)'}/>} />
                            </div>
                        </div>
                        {walletStore.shouldShowDeletePaymentMethodModal && <ConfirmDeletePaymentMethodModal store={walletStore} onCloseClick={() => walletStore.setShouldShowDeletePaymentMethodModal(false)} />}
                    </>
                ) : (
                    <div className="wallet-payment-method-add-new-method">
                        <Button
                            leftIcon={IconPlus}
                            variant={BUTTON_VARIANTS.Transparent}
                            text="Add payment method"
                            onClick={walletStore.addPaymentMethodHandler}
                        />
                    </div>
                )
            }
        </div>
    );
});

export default WalletPaymentMethod;